import * as ko from "knockout";
import Bao from "./../../services/bao-service";
function ConfigurationItemModuleViewModel(parent) {
    var self = this;
    self.Bao = Bao;
    self.parent = parent;
    self.ConfigurationItemTypes = ko.observableArray([]);
    self.ConfigurationItemTypeId = ko.observable();
    self.Initialized = ko.observable(false);
    self.ConfigurationItemCollection = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.SelectedRow = ko.observable({});
    self.SelectRow = function (item) {
        self.SelectedRow(item);
        return true;
    };
    self.DisplayTotalRows = ko.computed(function () {
        if (self.TotalRows() <= self.PageSize()) {
            return self.TotalRows();
        }
        else {
            return self.PageSize() + " / " + self.TotalRows();
        }
    });
    self.PageIndex.subscribe(function () {
        self.Load();
    });
    self.Sorting.subscribe(function () {
        self.Load();
    });
    self.ConfigurationItemTypeId.subscribe(function (item) {
        self.Load();
    });
    self.Load = function () {
        var def = $.Deferred();
        if (self.Initialized()) {
            Bao.post("SynosetStartModule/GetConfigurationItems", JSON.stringify({
                configurationItemTypeId: self.ConfigurationItemTypeId(),
                pageIndex: self.PageIndex(),
                pageSize: self.PageSize(),
                sorting: self.Sorting()
            }), function (searchResult) {
                self.SelectedRow(null);
                self.TotalRows(0);
                self.ConfigurationItemCollection([]);
                if (searchResult != null && searchResult.Models != null) {
                    self.ConfigurationItemCollection(searchResult.Models);
                    self.TotalRows(searchResult.TotalRows);
                }
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.parent.Refresh = function () {
        self.Load();
    };
    self.init = function () {
        return Bao.post("SynosetStartModule/GetConfigurationItemTypes", JSON.stringify({}), function (searchResult) {
            self.Initialized(true);
            self.ConfigurationItemTypes([]);
            if (searchResult != null) {
                self.ConfigurationItemTypes(searchResult);
                if (self.parent != null && self.parent.Parameter() != null) {
                    self.ConfigurationItemTypeId(self.parent.Parameter());
                }
            }
        });
    };
    self.loaded = function () {
        return self.Load();
    };
}
export default ConfigurationItemModuleViewModel;